// Unpublished Work © 2021-2024 Deere & Company.

export const GRAPH_COLORS = [
    '#FFFF82', '#D2AD79', '#05A1C9', '#993399',
    '#16C06B', '#99681E', '#8A0000', '#47C2B7',
    '#F2A33C', '#BFABCB', '#7464D0', '#0066AD',
    '#00FFC3', '#5F0066', '#8D8D8D', '#7B9CFF'
];

export const getGraphColor = (index) => {
    return GRAPH_COLORS[index % GRAPH_COLORS.length];
};
